// =========================================================
// * Vue Material Dashboard Laravel - v1.1.0
// =========================================================
//
// * Product Page: https://www.creative-tim.com/product/vue-material-dashboard-laravel
// * Copyright Creative Tim (https://www.creative-tim.com) & UPDIVISION (https://www.updivision.com)
//
// * Coded by www.creative-tim.com & www.updivision.com
//
// =========================================================
//
// * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

import Vue from "vue";
import axios from "axios";

// Plugins
import App from "./App.vue";
import Chartist from "chartist";
import VueAxios from "vue-axios";
import DashboardPlugin from "./material-dashboard";
import moment from 'moment';
import VueLoading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

// plugin setup
Vue.use(DashboardPlugin);
Vue.use(VueAxios, axios);
Vue.use(require('vue-moment'));
Vue.use(VueLoading, {
  // props
  color: 'blue',
},{
  // slots
});

// router & store setup
import router from "./router";
import store from "./store";

// global library setup
Vue.prototype.$Chartist = Chartist;

/* eslint-disable no-new */


// (async  () => {
//  await store.dispatch("profile/me")
//  console.log("jajaja")
// })();


router.beforeEach((to, from, next) => { 
  //console.log(to.matched[0].name)
  console.log(to)
  console.log(to.name)
  console.log(to.path)
  console.log("to.path")
  //console.log(to.from)
  //console.log(next)
  //check nama route yang akan dituju bukan not found 
  console.log(router.options.routes)
  
  if(store.getters["profile/me"] && Object.keys(store.getters["profile/me"]).length != 0){
    //console.log(store.getters["profile/me"])
    //  console.log(to.matched[0].name)
  (async  () => {
    console.log( to.matched)
  if( to.name!="Not Found" && to.matched[0].name!="User" && to.name!='Login' && to.name!='Landing Page' && to.name!='Home Page' ){
    
    var me = await store.getters["profile/me"]

   
    if(to.name=='Dashboard' && check_object_value(me.role_name,'division_id',[2])){
      return router.replace({ name: "Dashboard Bizdev" })
    }

    if(to.name=='Dashboard' && check_object_value(me.role_name,'division_id',[3])){
      return router.replace({ name: "Dashboard Workshop" })
    }

    if(to.name=='Dashboard' && check_object_value(me.role_name,'division_id',[4])){
      return router.replace({ name: "Dashboard Human Resource" })
    }

    if(!check_object_value(me.role_name,'division_id',[1])){
      console.log("division")
      if(to.matched[0].name == 'Bizdev' && !check_object_value(me.role_name,'division_id',[2,8])){
        console.log("not found")
        return router.replace({ name: "Not Found" })
      }
      //if(to.matched[0].name == 'Workshop' && me.role_name.division_id!=3){
      //   if(to.matched[0].name == 'Workshop' && !check_object_value(me.role_name,'division_id',[3])){
      //   check_object_value
      //   return router.replace({ name: "Not Found" })
      // }
      if(to.matched[0].name == 'Human Resources' && !check_object_value(me.role_name,'division_id',[4])){
        return router.replace({ name: "Not Found" })
      }
      if(to.matched[0].name == 'IT' && !check_object_value(me.role_name,'division_id',[5])){
        return router.replace({ name: "Not Found" })
      }
    }
    
     var indexOptionTestRoute = router.options.routes.findIndex(p => p.name == to.matched[0].name)
     console.log(indexOptionTestRoute)
     await store.dispatch("role_permission/commit_route", router.options.routes[indexOptionTestRoute]);
    
    // console.log(me.role)
    // console.log("aaaaaaa")
    var route_group = await store.getters["role_permission/route_group"]
     console.log(route_group)
     console.log("aaaaaaa")
    if(route_group || check_object_value(me.role_name,'division_id',[2,3,4])){
      //ambil list route group dari store
      var listRouteGroup = await store.getters["role_permission/route_group"].children
      //cari index dari route group yang memiliki nama route yang sama dengan nama route yang akan dituju
      var indexOptionRoute = listRouteGroup.findIndex(p => p.name == to.name)
      //  console.log(indexOptionRoute)
      //  console.log(listRouteGroup)
      //  console.log(me.role)
      //filter route sesuai dengan nama model
      var filter_route = me.role[listRouteGroup[indexOptionRoute].group]
    }
    
    
     
      
  if( to.matched[0].name != 'Finance'  && to.matched[0].name != 'User' && to.matched[0].name != 'Human Resource' && to.path!="/dashboard"){
    //check apakah group route ada didalam role user, jika tidak ada arahkan ke route not found
    console.log("matched")
    console.log(to.matched[0].name)
    console.log(filter_route)
    // if(!filter_route){
    //   return router.replace({ name: "Home Page" })
    // }
    // console.log("uuuuuuuuuuu")
    // if(filter_route){
      if(to.name.includes("List") && (filter_route.menu == 0) ){
        return router.replace({ name: "Not Found" })
        //return router.push({ name: "Not Found" });
      }
      else if(to.name.includes("Add") && filter_route.create == 0){
        return router.replace({ name: "Not Found" })
        //return router.push({ name: "Not Found" });
      }
      else if(to.name.includes("Edit") && filter_route.update == 0){
        return router.replace({ name: "Not Found" })
        //return router.push({ name: "Not Found" });
      }
    // }
    // else{
    //   return router.replace({ name: "Not Found" })
    // }

    
    if(!to.name.includes("Dashboard")){
      //filter_route.role = me.role_name.name 
      console.log("filter_route")
      console.log(filter_route)
       await store.dispatch("role_permission/commit_route_filter", filter_route)
     }
  }

    
    return next();
  }
  else{
    return next();
  }
  })();
}
else{
  return next();
}
  
})


const app = new Vue({
  router: router,
  store: store,
  momment: moment,
  el: "#app",
  render: h => h(App)
});

    // async function hello() { 
    //   await store.dispatch("profile/me"); 
    //   return console.log("yaya") 

      
    // };
    function check_object_value(array, key, value) {
      //return array.some(object => object[key] === value);
      return array.some(object => value.includes(object[key]));
      };

  

    let loader= null

    axios.interceptors.request.use(function(config) {
      // Do something before request is sent
      //console.log('Start Ajax Call');
      if(loader && loader.hide()){
        loader.hide()
       loader = Vue.$loading.show();
      }
      else{
        loader = Vue.$loading.show();
      }
      return config;
    }, function(error) {
      // Do something with request error
      console.log('Error');
      return Promise.reject(error);
    });
    
    axios.interceptors.response.use(function(response) {
      // Do something with response data
     // console.log('Done with Ajax call');
     // console.log(loader)
      loader.hide()
      return response;
    }, function(error) {
      // Do something with response error
      loader.hide()
      console.log('Error fetching the data');
      console.log(error);
      store.dispatch(
        "alerts/error_message",
        error.response
      );
      console.log(error.response);
      
      return Promise.reject(error);
    });

    
store.$app = app;